import { TotalRateType } from 'types';
import { translations } from 'translations/en';

export const mapRateTypeToText = {
  [TotalRateType.One]: translations.SHOP.TERRIBLE,
  [TotalRateType.Two]: translations.SHOP.POOR,
  [TotalRateType.Three]: translations.SHOP.AVERAGE,
  [TotalRateType.Four]: translations.SHOP.VERY_GOOD,
  [TotalRateType.Five]: translations.SHOP.EXCELLENT,
};
